export default __webpack_public_path__ + "static/media/Clínica-Taquari.df90f1a6.png";